/**
 * Capitalize only first letter of the text
 * @param text {string} - string to capitalize
 * @returns {string}
 */

const capitalize = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};
export default capitalize;
